module.exports = __webpack_public_path__ + "static/img/logo.cc1d2cd7.png";